import { useQuery } from '@tanstack/react-query';
import { productKpisService, type ReportParams } from '../services/product-kpis.service';

export function useProductKpis(params: ReportParams = {}) {
  return useQuery({
    queryKey: ['product-kpis', params],
    queryFn: () => productKpisService.getReport(params),
    staleTime: 60_000,
  });
}
